import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { RouteFetcherContext } from '@mk-redbox/route-fetcher';

const containerStyle = {
  padding: '0.2em',
  border: '1px solid #000',
  background: '#5f5f5f'
};

const TextSelectionMenu = ({
  openAddDxDialog,
  dateOfService
}) => {
  const backendRoutes = useContext(RouteFetcherContext);

  return (
    <div style={containerStyle}>
      <div>
        <button
          onClick={() => openAddDxDialog(window.getSelection().toString())}
        >
          <span>ADD DX</span>
        </button>

        <button
          style={{ marginLeft: '0.1em' }}
          onClick={() => {
            const { EncoderJump } = backendRoutes;
            const year = new Date(dateOfService).getUTCMonth() >= 9 ?
              new Date(dateOfService).getUTCFullYear()+1 :
              new Date(dateOfService).getUTCFullYear();
            const selectedText = window.getSelection().toString();

            window.open(`${EncoderJump}?year=${year}&term=${selectedText}`, '_blank');
          }}
        >
          <span>ENCODER</span>
        </button>
      </div>
    </div>
  );
};

TextSelectionMenu.propTypes = {
  openAddDxDialog: PropTypes.func.isRequired,
  dateOfService: PropTypes.string.isRequired
};

export default TextSelectionMenu;
